import React from 'react';

import TooltipIcon, { TooltipIconProps } from 'common/controls/items/TooltipIcon';

const TooltipHint: React.FC<TooltipIconProps> = (props) => <TooltipIcon {...props} iconName="InfoSolid" />;

export default TooltipHint;
